import { Star } from "lucide-react";

const reviews = [
  {
    name: "Verified Guest",
    where: "Bengaluru",
    text: "A nice homestay in the middle of coffee plantation. We thoroughly enjoyed the hospitality from the hosts Harsha and Sushma. Home food was delicious. Harsha also took us to Watehole Dam for a nice sunset and Parvathamma Betta for a short trek — beautiful and peaceful places. We kept getting served with fruits from their own plantation! Seeing and hearing peacocks made us feel the place as it is named.",
  },
  {
    name: "Family Traveller",
    where: "Mangaluru",
    text: "It was a very pleasant stay at Navilu Kallu, close to nature and amidst the tranquil environment of Sakleshpur. The owner Harsha, his wife and their two children took care of us very well during our entire stay. They took us in their car to the nearby attractions — Lake Placid, Hoysaleshwara Temple (Halebeedu) — and even treated us to an evening barbeque with drinks and bonfire. Hospitality is in their blood. I wish to visit Navilukallu again.",
  },
  {
    name: "Weekend Guest",
    where: "Chikkamagaluru",
    text: "Experienced one of the best hospitalities and hidden treasures here. Tasted typical Sakleshpur food — exactly what I was expecting. Very nice place to unwind, relax and refresh. Rooms are super comfy, the daily view gives a complete view of the garden. Hot water 24×7. You can take a walk in the property that has a mix of forest and farm feel. The owner is a gem — passionate and caring about how you enjoy your stay. ✨❤",
  },
  {
    name: "Priya & Arjun",
    where: "Bengaluru",
    text: "One of the best homestays we have ever visited. The food was amazing and the coffee estate walk was unforgettable.",
  },
  {
    name: "Ravi Kumar",
    where: "Mysuru",
    text: "Beautiful Malnad house with peaceful surroundings. Highly recommended for families.",
  },
  {
    name: "The Nair Family",
    where: "Kochi",
    text: "The campfire, rain dance, and authentic hospitality made our vacation truly memorable.",
  },
  {
    name: "Sneha D.",
    where: "Mumbai",
    text: "Perfect place to relax away from the city. Delicious homemade food and stunning views.",
  },
  {
    name: "Arun & Team",
    where: "Chennai",
    text: "A hidden gem near Belur. We can't wait to visit again!",
  },
];

const Card = ({ r }) => (
  <div className="w-[320px] sm:w-[400px] shrink-0 mr-6 rounded-3xl bg-white p-7 border border-[#1B4332]/10 shadow-sm">
    <div className="flex items-center gap-1 text-[#D4AF37]">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} size={16} fill="#D4AF37" strokeWidth={0} />
      ))}
    </div>
    <p className="mt-4 font-heading italic text-[#1A1A1A]/90 text-[15px] md:text-base leading-relaxed line-clamp-[10]">
      “{r.text}”
    </p>
    <div className="mt-5 pt-4 border-t border-[#1B4332]/10">
      <div className="font-medium text-[#1B4332]">{r.name}</div>
      <div className="text-xs text-[#1A1A1A]/50 tracking-wide">{r.where}</div>
    </div>
  </div>
);

const Testimonials = () => {
  const loop = [...reviews, ...reviews];
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-[#F8FAF7] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="max-w-2xl reveal">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-[#D4AF37]" />
            <span className="text-[11px] tracking-[0.3em] uppercase text-[#D4AF37] font-medium">
              Testimonials
            </span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-[#1B4332] leading-[1.05] tracking-tight">
            Loved by{" "}
            <span className="italic font-light">our guests</span>
          </h2>
        </div>
      </div>

      <div className="mt-14 relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#F8FAF7] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#F8FAF7] to-transparent z-10" />
        <div className="overflow-hidden">
          <div className="flex w-max marquee-track">
            {loop.map((r, i) => (
              <Card r={r} key={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
